module.exports = __webpack_public_path__ + "static/media/HB_thaicurry_forweb_new_edited.eec2ccc9.jpg";